import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/d97ae9ac8355a0d5876385dc4a41e6c7af024c07.jpg";
import "./thankspage.css";

const Thankspage = () => {
  return (
    <div
      className="body-inner"
     style={{
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  color:"whitesmoke",
  fontFamily:"Lora",
  // background: "linear-gradient( #9DC586, #20544A)"
  // background: "linear-gradient(  #20544A, #9DC586)"


  //  background: "linear-gradient(to right, #061700, #52c234)"
  //  background: "linear-gradient(to top, #0f9b0f, #000000)"
  background: "radial-gradient(circle, rgba(21, 161, 67, 1) 0%, rgba(25, 105, 58, 1) 50%, rgba(21, 161, 67, 1) 100%)"
//  background: "radial-gradient(circle, rgba(42,201,82,1) 0%, rgba(10,79,14,1) 100%)"
}}

    >
      <h4 style={{ textAlign: "center" }}>Thank You for Visiting <span className='text-change'>Electiaa</span>, !
      </h4><br>
      </br>
      <a href="/">
        <img src={logo} alt="FAZO Academy Logo" width="120" />
      </a> <br></br>
      <h1 className="m-t-50 font-weight-bold " style={{ color:"#061700"}}>Thanking you</h1>
      <p className="lead" style={{ textAlign: "center" , fontFamily:"Lora" }}>
        <strong>We appreciate your trust in us.</strong><br></br><br></br>
       Let’s develop your digital presence to perfection.

        {/* <strong>Your Dream, Our Expertise!</strong> */}
      </p>
      <Link
        to="/" className="thankpage"
        
        // style={{
        //   backgroundColor: "#354169",
        //   color: "#FDC30B",
        //   margin: "20px",
        //   padding: "10px",
        //   borderRadius: "5px",
        //   textDecoration: "none",

        // }}
      >
        Go to home page
      </Link>
    </div>
  );
};

export default Thankspage;
